import { ResetpasswordComponent } from "./../../auth/resetpassword/resetpassword.component";
import { Component, OnInit, ElementRef } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import { SessionService } from "../../services/session.service";
import { environment } from "../../../environments/environment";
import Swal from "sweetalert2";
import { Md5 } from "ts-md5/dist/md5";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { UtilityService } from "src/app/services/utility.service";
import * as $ from "jquery";
import { SharedService } from "src/app/services/shared.service";

@Component({
  selector: "app-Inboundregistration",
  templateUrl: "./Inboundregistration.component.html",
  styleUrls: ["./Inboundregistration.component.scss"],
})
export class InboundregistrationComponent implements OnInit {
  apiUrl: string;
  registerForm: FormGroup;
  timeout: any = null;
  preboardingForm: FormGroup;
  covidTestForm: FormGroup;
  submitted = false;
  loginLogo: boolean;
  personalInfoTab: boolean = true;
  paymentTab: boolean;
  confirmationTab: boolean;
  personalInfo: any;
  appointmentForm: FormGroup;
  paymentGatewayForm: FormGroup;
  otpForm: FormGroup;
  requestObj: any;
  bookAppointmentTab: boolean;
  covidTab: boolean;
  healthDeclarationTab: boolean;
  travelInfo: any;
  countriesVisited: string[] = [];
  health_declaration_info: any;
  destinations: {
    address: string;
    state: string;
    city: string;
  }[] = [];
  destinationAddress: any[] = [];
  destinationCity: any[] = [];
  destinationState: any[] = [];
  travelTypes: any;

  address: boolean;
  invalidAddress: boolean;
  state: boolean;
  invalidState: boolean;
  city: boolean;
  invalidCity: boolean;
  isDestination: boolean;
  questionniare: any;
  file: any;
  filePath: any;
  covidtest_info: any;
  fileUrl: any;
  centerId = 0;
  centerAmount = 0;
  arrivalDate: any;
  imageName: string;
  bookingForm: FormGroup;
  booking_info: any;
  fullName: string;
  passportNumber: any;
  travelDate: any;
  appointment: string;
  noCountry: boolean;
  noDestination: boolean = false;
  linkDisabled: boolean;
  isAgreed: boolean;
  kinInfo: any;
  collectionCenters: any;
  preferredLocation: any;
  centerName: any;
  date: Date;
  checkAgree: boolean = false;
  questionnaires: any;
  passportDetails: any;
  symptoms: any;
  confirmed: boolean = false;

  passengerInformation: any;
  passengerEmailAddress: string = "";

  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router,
    public utility: UtilityService,
    private spinnerService: Ng4LoadingSpinnerService,
    private el: ElementRef,
    public shared: SharedService
  ) {
    this.symptoms = [
      { name: "fever1", value: 0 },
      { name: "cough1", value: 0 },
      { name: "dib1", value: 0 },
      { name: "gfUnwell1", value: 0 },
      { name: "sneezing1", value: 0 },
      { name: "otherSymptoms1", value: 0 },
      { name: "fever2", value: 0 },
      { name: "cough2", value: 0 },
      { name: "dib2", value: 0 },
      { name: "gfUnwell2", value: 0 },
      { name: "sneezing2", value: 0 },
      { name: "otherSymptoms2", value: 0 },
      { name: "para", value: 0 },
      { name: "antibiotics", value: 0 },
      { name: "commonCold", value: 0 },
      { name: "antiviral", value: 0 },
    ];
  }

  ngOnInit() {
    this.loginLogo = true;
    // this.sess.islogin();
    this.spinnerService.show();
    this.date = new Date();
    this.initialiseRegistrationForm();
    this.initPreboardingForm();
    this.spinnerService.hide();
    $(".mobile-menu").css("display", "none");
    this.getQuestionnaires();
    this.getTravelTypes();
    this.getCollectionCenters();

    this.initPaymentGatewayForm();
    this.initialiseOtpForm();
    this.shared.getCountries();
  }

  initialiseRegistrationForm() {
    this.registerForm = this.formBuilder.group(
      {
        emailAddress: [
          "",
          [Validators.required, Validators.maxLength(45), Validators.email],
        ],
        confirmEmailAddress: [
          "",
          [Validators.required, Validators.maxLength(45), Validators.email],
        ],
        firstName: [
          "",
          [
            Validators.required,
            Validators.pattern("^[A-Za-z ]*$"),
            // Validators.pattern("^[a-zA-Z]+ [a-zA-Z]+$"),
            // Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
            Validators.maxLength(45),
          ],
        ],
        middleName: [
          "",
          [
            // Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
            // Validators.pattern("^[a-zA-Z]+ [a-zA-Z]+$"),
            Validators.pattern("^[A-Za-z ]*$"),
            Validators.maxLength(45),
          ],
        ],
        lastName: [
          "",
          [
            Validators.required,
            // Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
            // Validators.pattern("^[a-zA-Z]+ [a-zA-Z]+$"),
            Validators.pattern("^[A-Za-z ]*$"),
            Validators.maxLength(45),
          ],
        ],
        countryDeparting: [
          "",
          [
            Validators.required,
            Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
          ],
        ],

        nationality: [
          "",
          [
            Validators.required,
            Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
          ],
        ],
        phone: [
          "",
          [
            Validators.required,
            Validators.pattern("^[0-9]*$"),
            Validators.minLength(9),
          ],
        ],
        passportNumber: [
          "",
          [
            Validators.required,
            Validators.pattern("^[A-PR-WY][1-9]ds?d{4}[1-9]$"),
            // Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
            Validators.minLength(8),
            Validators.maxLength(15),
          ],
        ],
        gender: ["", Validators.required],
        // airline: ['', Validators.required],
        arrivalDate: ["", Validators.required],
        arrivalState: [
          "",
          [
            Validators.required,
            Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
          ],
        ],
        // countryOfTransit: ['', Validators.required,Validators.pattern('^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$'),],
        countryOfTransit: [""],
        countryOfResidence: [
          "",
          Validators.required,
          Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
        ],
        // returnDate: ['', Validators.required],
        dateOfBirth: ["", Validators.required],
        currentAddress: [
          "",
          [
            Validators.required,
            Validators.maxLength(60),
            Validators.pattern(
              "^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 -,./_)(&+)]*$"
            ),
          ],
        ],
        occupation: [
          "",
          [
            Validators.required,
            Validators.maxLength(45),
            Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
          ],
        ],
      },
      {
        validator: this.utility.MustMatch(
          "emailAddress",
          "confirmEmailAddress"
        ),
      }
    );
  }

  initPreboardingForm() {
    this.preboardingForm = this.formBuilder.group({
      address: [""],
      kinAddress: [
        "",
        [
          Validators.required,
          Validators.pattern(
            "^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 -,./_)(&+]*$"
          ),
        ],
      ],
      countriesVisited: ["", Validators.required],
      kinPhoneNumber: [
        "",
        [
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.minLength(9),
        ],
      ],
      state: ["", [Validators.pattern("^[A-Za-z ]*$")]],
      city: ["", [Validators.pattern("^[A-Za-z ]*$")]],
      kinFullname: [
        "",
        [
          Validators.required,
          Validators.pattern("^[A-Za-z ]*$"),
          // Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
        ],
      ],
    });
  }

  preboardingFormUpdate(kinInfo) {
    this.preboardingForm = this.formBuilder.group({
      address: [""],
      kinAddress: [
        kinInfo.address,
        [
          Validators.required,
          Validators.pattern(
            "^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 -,./_)(&+]*$"
          ),
        ],
      ],
      countriesVisited: [""],
      kinPhoneNumber: [
        kinInfo.phone,
        [
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.minLength(9),
        ],
      ],
      state: [""],
      city: [""],
      kinFullname: [
        kinInfo.fullname,
        [
          Validators.required,
          Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
        ],
      ],
    });
    this.kinInfo = "";
  }

  initCovidForm() {
    this.covidTestForm = this.formBuilder.group({
      testResult: ["", [Validators.required]],
      labEmail: [
        "",
        [
          Validators.required,
          Validators.maxLength(45),
          Validators.email,
          this.utility.emailMustNotEqual(this.passengerEmailAddress),
        ],
      ],
      labPhone: [
        "",
        [
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.minLength(9),
        ],
      ],
      resultFile: ["", Validators.required],
      dateDone: ["", Validators.required],
      labName: [
        "",
        [
          Validators.required,
          Validators.pattern(
            "^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 -,./_)(&+]*$"
          ),
        ],
      ],
      labCountry: [
        "",
        [
          Validators.required,
          Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
        ],
      ],
    });
  }

  updateCovidForm(covidtestInfo) {
    this.covidTestForm = this.formBuilder.group({
      testResult: [covidtestInfo.test_result, [Validators.required]],
      labEmail: [
        covidtestInfo.lab_email,
        [
          Validators.required,
          Validators.maxLength(45),
          Validators.email,
          this.utility.emailMustNotEqual(this.passengerEmailAddress),
        ],
      ],
      labPhone: [
        covidtestInfo.lab_phone,
        [
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.minLength(9),
        ],
      ],
      resultFile: [this.file, Validators.required],
      dateDone: [covidtestInfo.test_date, Validators.required],
      labName: [
        covidtestInfo.lab_name,
        [
          Validators.required,
          Validators.pattern(
            "^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 -,./_)(&+]*$"
          ),
        ],
      ],
      labCountry: [
        covidtestInfo.country,
        [
          Validators.required,
          Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
        ],
      ],
    });
  }

  initBookingForm() {
    this.appointmentForm = this.formBuilder.group({
      stateOnDay7: [
        "",
        [
          Validators.required,
          Validators.pattern("^[a-z A-Z]+$"),
          // Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
        ],
      ],
      arrivalDate: [""],
      bookingDate: ["", [Validators.required]],
      bookingTime: ["", [Validators.required]],
      cityOnDay7: [
        "",
        [
          Validators.required,
          Validators.pattern("^[a-zA-Z ]+$"),
          // Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
        ],
      ],
    });
  }

  initPaymentGatewayForm() {
    this.paymentGatewayForm = this.formBuilder.group({
      amount: [
        this.centerAmount,
        [
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.minLength(1),
        ],
      ],
      cardNumber: [
        "",
        [
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.minLength(15),
        ],
      ],
      expiryDateMonth: [
        "Month",
        [
          Validators.required,
          // Validators.pattern("^[0-9]*$"),
          // Validators.minLength(2),
        ],
      ],
      expiryDateYear: [
        "Year",
        [
          Validators.required,
          // Validators.pattern("^[0-9]*$"),
          // Validators.minLength(4),
        ],
      ],
      ccvCode: [
        "",
        [
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.minLength(3),
        ],
      ],
      cardHolderName: [
        "",
        [Validators.required, Validators.pattern("^[a-z A-Z]+$")],
      ],
      saveCardDetails: [false],
    });
  }

  updatePaymentGatewayForm(data: any) {
    this.paymentGatewayForm = this.formBuilder.group({
      amount: [data.amount, [Validators.required]],
      cardNumber: [data.cardNumber, [Validators.required]],
      expiryDateMonth: [data.expiryDateMonth, [Validators.required]],
      expiryDateYear: [data.expiryDateYear, [Validators.required]],
      ccvCode: [data.ccvCode, [Validators.required]],
      cardHolderName: [data.cardHolderName, [Validators.required]],
      saveCardDetails: [data.saveCardDetails],
    });
  }

  initialiseOtpForm() {
    this.otpForm = this.formBuilder.group({
      enterOtp: ["", [Validators.required, Validators.pattern(/^[0-9]*$/)]],
    });
  }

  onSubmitPersonalInfo(formData) {
    this.submitted = true;

    if (this.registerForm.invalid) {
      for (const key of Object.keys(this.registerForm.controls)) {
        if (this.registerForm.controls[key].invalid) {
          const invalidControl = this.el.nativeElement.querySelector(
            '[formcontrolname="' + key + '"]'
          );
          invalidControl.focus();
          break;
        }
      }

      return;
    }

    this.personalInfo = {
      passport_no: formData.passportNumber,
      phone: formData.phone,
      email: formData.emailAddress,
      address_residential: formData.currentAddress,
      confirm_email: formData.confirmEmailAddress,
      first_name: formData.firstName,
      middle_name: formData.middleName,
      last_name: formData.lastName,
      nationality: formData.nationality,
      dob: formData.dateOfBirth,
      country_residence: formData.countryOfResidence,
      // airline: formData.airline,
      occupation: formData.occupation,
      gender: formData.gender,
    };
    this.travelInfo = {
      arrival_date: formData.arrivalDate,
      arrival_state: formData.arrivalState,
      transit_country: formData.countryOfTransit,
      arrival_country: formData.countryDeparting,
      type: "2",
    };
    // this.fullName = `${formData.firstName} ${formData.middleName} ${formData.lastName}`;
    this.fullName =
      formData.firstName + " " + formData.middleName + " " + formData.lastName;

    this.arrivalDate = formData.arrivalDate;
    this.travelDate = formData.arrivalDate;
    this.passportNumber = formData.passportNumber;

    this.passengerEmailAddress = formData.emailAddress;

    // console.log('person ', this.personalInfo);
    // console.log('travel ', this.travelInfo);
    this.submitted = false;
    if (this.kinInfo == null) {
      this.showHealthDeclaration();
    } else {
      this.backHealthDeclaration();
    }
  }

  onSubmitPreboarding(formData) {
    this.kinInfo = {};
    this.submitted = true;

    if (this.preboardingForm.invalid) {
      for (const key of Object.keys(this.preboardingForm.controls)) {
        if (this.preboardingForm.controls[key].invalid) {
          const invalidControl = this.el.nativeElement.querySelector(
            '[formcontrolname="' + key + '"]'
          );
          invalidControl.focus();
          break;
        }
      }

      if (this.countriesVisited.length == 0) {
        this.noCountry = true;
      }
      // if (this.preboardingForm.get("countriesVisited").value == "") {
      // } else {
      //   return;
      // }
      if (this.destinations.length == 0) {
        this.noDestination = true;
        return;
      }
      return;
    }

    if (this.destinations.length == 0) {
      this.noDestination = true;
      return;
    } else {
      this.noDestination = false;
    }
    if (this.countriesVisited.length == 0) {
      this.noCountry = true;
      return;
    }
    for (let i = 0; i < this.destinations.length; i++) {
      this.destinationAddress.push(this.destinations[i].address);
      this.destinationState.push(this.destinations[i].state);
      this.destinationCity.push(this.destinations[i].city);
      console.log("address ", this.destinationAddress);
    }
    // this.noCountry = false;
    this.noCountry = false;
    this.health_declaration_info = {
      countries_visited: this.countriesVisited,
      eg_destination_address: this.destinationAddress,
      eg_destination_state: this.destinationState,
      eg_destination_city: this.destinationCity,
      emergency_contact_fullname: formData.kinFullname,
      emergency_contact_phone: formData.kinPhoneNumber,
      emergency_contact_address: formData.kinAddress,
    };
    this.kinInfo = {
      address: formData.kinAddress,
      fullname: formData.kinFullname,
      phone: formData.kinPhoneNumber,
    };

    this.questionniare = {
      1: [
        { question_id: "1", answer: this.symptoms[0].value, type: "radio" },
        { question_id: "2", answer: this.symptoms[1].value, type: "radio" },
        { question_id: "3", answer: this.symptoms[2].value, type: "radio" },
        { question_id: "4", answer: this.symptoms[3].value, type: "radio" },
        { question_id: "5", answer: this.symptoms[4].value, type: "radio" },
        { question_id: "6", answer: this.symptoms[5].value, type: "radio" },
      ],
      2: [
        { question_id: "7", answer: this.symptoms[6].value, type: "radio" },
        { question_id: "8", answer: this.symptoms[7].value, type: "radio" },
        { question_id: "9", answer: this.symptoms[8].value, type: "radio" },
        { question_id: "10", answer: this.symptoms[9].value, type: "radio" },
        { question_id: "11", answer: this.symptoms[10].value, type: "radio" },
        { question_id: "12", answer: this.symptoms[11].value, type: "radio" },
      ],
      3: [
        { question_id: "13", answer: this.symptoms[12].value, type: "radio" },
        { question_id: "14", answer: this.symptoms[13].value, type: "radio" },
        { question_id: "15", answer: this.symptoms[14].value, type: "radio" },
        { question_id: "16", answer: this.symptoms[15].value, type: "radio" },
      ],
    };
    this.submitted = false;
    this.showCovid();
    this.utility.gotoTop();
  }

  onSubmitAppointment(formData) {
    this.submitted = true;
    if (this.appointmentForm.invalid) {
      for (const key of Object.keys(this.appointmentForm.controls)) {
        if (this.appointmentForm.controls[key].invalid) {
          const invalidControl = this.el.nativeElement.querySelector(
            '[formcontrolname="' + key + '"]'
          );
          invalidControl.focus();
          break;
        }
      }
      return;
    }
    if (this.confirmed == false) {
      Swal.fire({
        icon: "info",
        title: "Confirm Booking slot",
        text: "Please confirm booking date and Time slot.",
        showConfirmButton: true,
        timer: 5000,
      });
      return;
    }

    if (this.centerId == 0) {
      Swal.fire({
        icon: "info",
        title: "Oops...",
        text: "Please a center for the test.",
        showConfirmButton: true,
        timer: 5000,
      });
      return;
    }

    this.submitted = false;

    this.booking_info = {
      booking_date: formData.bookingDate,
      booking_time: formData.bookingTime,
      center_id: this.centerId,
      expected_state: formData.stateOnDay7,
      expected_city: formData.cityOnDay7,
    };
    this.preferredLocation = {
      state: this.appointmentForm.get("stateOnDay7").value,
      city: this.appointmentForm.get("cityOnDay7").value,
      bookingTime: this.appointmentForm.get("bookingTime").value,
      bookingDate: this.appointmentForm.get("bookingDate").value,
    };
    this.appointment = `${this.preferredLocation.bookingDate} ${this.preferredLocation.bookingTime}`;
    this.showConfirmation();
    this.utility.gotoTop();
  }

  onSubmitCovidTest(formData) {
    this.submitted = true;

    if (this.covidTestForm.invalid || this.isAgreed != true) {
      for (const key of Object.keys(this.covidTestForm.controls)) {
        if (this.covidTestForm.controls[key].invalid) {
          const invalidControl = this.el.nativeElement.querySelector(
            '[formcontrolname="' + key + '"]'
          );
          invalidControl.focus();
          break;
        }
      }
      // this.checkAgree = true;
      return;
    }
    this.submitted = false;

    this.covidtest_info = {
      test_result: formData.testResult,
      test_date: formData.dateDone,
      lab_name: formData.labName,
      lab_phone: formData.labPhone,
      report_url: this.fileUrl,
      lab_email: formData.labEmail,
      country: formData.labCountry,
      // resultFile: this.fileUrl,
    };
    if (this.preferredLocation == null) {
      this.showBookAppointment();
    } else {
      this.backBookAppointment();
      this.utility.gotoTop();
    }
  }

  checkValue(event: any) {
    if (event == true) {
      this.checkAgree = false;
    } else {
      this.checkAgree = true;
    }
    console.log(event);
  }

  submitInbound() {
    if (this.confirmed == false) {
      Swal.fire({
        icon: "error",
        title: "Confirm Time slot",
        text: "Please confirm Booking date and time slot.",
        showConfirmButton: true,
        timer: 5000,
      });
      return;
    } else {
      const request = {
        passenger_info: this.personalInfo,
        travel_info: this.travelInfo,
        health_declaration_info: this.health_declaration_info,
        questionnaire: this.questionniare,
        covidtest_info: this.covidtest_info,
        booking_info: this.booking_info,
      };
      this.spinnerService.show();

      this.apiUrl = environment.AUTHAPIURL + "passenger-inbound/register";

      this.http.post<any>(this.apiUrl, request).subscribe((data) => {
        console.log("registerApiResponse: ", data);
        this.passengerInformation = data.response;
        this.spinnerService.hide();

        if (data.status == true) {
          this.confirmed = true;
          Swal.fire({
            icon: "success",
            title: "Success",
            text: data.message,
            showConfirmButton: true,
            timer: 5000,
          });
          this.showPayment();
          this.utility.gotoTop();
        } else {
          this.confirmed = false;
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text:
              data.response != null ? data.response[0].message : data.message,
            showConfirmButton: true,
            timer: 5000,
          });
        }
      });
    }
  }

  submitCountry() {
    let data = this.preboardingForm.get("countriesVisited").value;
    let confirm = /[a-zA-Z]/g.test(data);
    if (!confirm) {
      this.noCountry = true;
      console.log("data empty");
    } else {
      this.noCountry = false;
      this.countriesVisited.push(data);
      this.preboardingForm.get("countriesVisited").setValue(" ");
    }
  }
  removeCountry(country) {
    this.countriesVisited = this.countriesVisited.filter((e) => e !== country);
  }
  removeAddress(address) {
    this.destinations = this.destinations.filter((e) => e !== address);
  }
  addDestination() {
    let address = this.preboardingForm.get("address").value;
    let state = this.preboardingForm.get("state").value;
    let city = this.preboardingForm.get("city").value;

    this.invalidAddress = false;
    this.invalidState = false;
    this.invalidCity = false;

    if (!/^[A-Za-z 0-9 ]*$/i.test(address)) {
      this.invalidAddress = true;
    }
    if (!/^[A-Za-z ]*$/i.test(state)) {
      this.invalidState = true;
    }
    if (!/^[A-Za-z ]*$/i.test(city)) {
      this.invalidCity = true;
    }

    if (this.invalidAddress || this.invalidState || this.invalidCity) {
      return;
    }

    if (address == "") {
      this.address = true;
    } else if (state == "") {
      this.state = true;
    } else if (city == "") {
      this.city = true;
    } else {
      let newDestination = {
        address: this.preboardingForm.get("address").value,
        state: this.preboardingForm.get("state").value,
        city: this.preboardingForm.get("city").value,
      };
      this.destinations.push(newDestination);
      this.noDestination = false;
      this.address = false;
      this.state = false;
      this.city = false;
    }
    if (!this.address && !this.state && !this.city) {
      this.preboardingForm.get("address").setValue("");
      this.preboardingForm.get("state").setValue("");
      this.preboardingForm.get("city").setValue("");
    }
  }

  showPersonalInfo() {
    this.personalInfoTab = true;
    this.bookAppointmentTab = false;
    this.confirmationTab = false;
    this.paymentTab = false;
    this.covidTab = false;
    this.healthDeclarationTab = false;
    this.kinInfo = {
      address: this.preboardingForm.get("kinAddress").value,
      fullname: this.preboardingForm.get("kinFullname").value,
      phone: this.preboardingForm.get("kinPhoneNumber").value,
    };
    this.utility.gotoTop();
  }

  confirmTimeSlot() {
    this.confirmed = true;
    const obj = {
      booking_time: this.appointmentForm.get("bookingTime").value,
      booking_date: this.appointmentForm.get("bookingDate").value,
      center_id: this.centerId,
    };
    this.apiUrl = environment.AUTHAPIURL + "verify-booking-slot";

    this.http.post<any>(this.apiUrl, obj).subscribe((data) => {
      console.log("verify booking: ", data);
      this.spinnerService.hide();

      if (data.status == true) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.message,
          showConfirmButton: true,
          timer: 5000,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: data.response != null ? data.response[0].message : data.message,
          showConfirmButton: true,
          timer: 5000,
        });
      }
    });
  }

  showCovid() {
    if (this.preboardingForm.valid && this.countriesVisited.length < 0) {
      Swal.fire({
        icon: "error",
        title: "",
        text: "Please add countries visitede in the last 21 days.",
        showConfirmButton: true,
        timer: 5000,
      });
      return;
    } else if (this.preboardingForm.valid && this.countriesVisited.length > 0) {
      this.personalInfoTab = false;
      this.bookAppointmentTab = false;
      this.confirmationTab = false;
      this.paymentTab = false;
      this.covidTab = true;
      this.healthDeclarationTab = false;
      this.submitted = false;
      if (this.covidtest_info) {
        this.backtoCovid();
      } else {
        this.initCovidForm();
      }
    } else if (
      this.preboardingForm.invalid &&
      this.countriesVisited.length < 0
    ) {
      Swal.fire({
        icon: "error",
        title: " ",
        text: "Please complete the required fields and Countries Visited.",
        showConfirmButton: true,
        timer: 5000,
      });
      return;
    } else if (
      this.preboardingForm.invalid &&
      this.countriesVisited.length > 0
    ) {
      this.personalInfoTab = false;
      this.bookAppointmentTab = false;
      this.confirmationTab = false;
      this.paymentTab = false;
      this.covidTab = true;
      this.healthDeclarationTab = false;
      this.submitted = false;
      if (this.covidtest_info) {
        this.backtoCovid();
      } else {
        this.initCovidForm();
      }
    }
  }

  backtoCovid() {
    if (this.preboardingForm.invalid) {
      Swal.fire({
        icon: "error",
        title: "",
        text: "Please complete the required fields first.",
        showConfirmButton: true,
        timer: 5000,
      });
      return;
    } else {
      this.confirmed = false;
      this.personalInfoTab = false;
      this.bookAppointmentTab = false;
      this.confirmationTab = false;
      this.paymentTab = false;
      this.covidTab = true;
      this.healthDeclarationTab = false;
      this.submitted = false;
      this.updateCovidForm(this.covidtest_info);
      this.preferredLocation = {
        state: this.appointmentForm.get("stateOnDay7").value,
        city: this.appointmentForm.get("cityOnDay7").value,
        bookingTime: this.appointmentForm.get("bookingTime").value + ":00",
        bookingDate: this.appointmentForm.get("bookingDate").value,
      };
    }
    this.utility.gotoTop();
  }

  showHealthDeclaration() {
    if (this.registerForm.invalid) {
      Swal.fire({
        icon: "error",
        title: "",
        text: "Please complete the required fields first.",
        showConfirmButton: true,
        timer: 5000,
      });
      return;
    } else {
      this.personalInfoTab = false;
      this.bookAppointmentTab = false;
      this.confirmationTab = false;
      this.paymentTab = false;
      this.covidTab = false;
      this.healthDeclarationTab = true;
      this.submitted = false;
      this.initPreboardingForm();
    }
  }

  backHealthDeclaration() {
    if (this.registerForm.invalid) {
      Swal.fire({
        icon: "error",
        title: "",
        text: "Please complete the required fields first.",
        showConfirmButton: true,
        timer: 5000,
      });
      return;
    } else {
      this.personalInfoTab = false;
      this.bookAppointmentTab = false;
      this.confirmationTab = false;
      this.paymentTab = false;
      this.covidTab = false;
      this.healthDeclarationTab = true;
      this.submitted = false;
      this.preboardingFormUpdate(this.kinInfo);
      this.utility.gotoTop();
    }
  }

  showBookAppointment() {
    if (this.covidTestForm.invalid) {
      Swal.fire({
        icon: "error",
        title: "",
        text: "Please complete the required fields first.",
        showConfirmButton: true,
        timer: 5000,
      });
      return;
    } else {
      this.personalInfoTab = false;
      this.bookAppointmentTab = true;
      this.confirmationTab = false;
      this.paymentTab = false;
      this.covidTab = false;
      this.submitted = false;
      this.healthDeclarationTab = false;

      this.appointmentForm = this.formBuilder.group({
        stateOnDay7: [
          "",
          [
            Validators.required,
            Validators.pattern("^[a-zA-Z ]+$"),
            // Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
          ],
        ],
        arrivalDate: [this.arrivalDate],
        bookingDate: ["", [Validators.required]],
        bookingTime: ["", [Validators.required]],
        cityOnDay7: [
          "",
          [
            Validators.required,
            Validators.pattern("^[a-zA-Z ]+$"),
            // Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
          ],
        ],
      });
    }
  }

  backBookAppointment() {
    if (this.registerForm.invalid) {
      Swal.fire({
        icon: "error",
        title: "",
        text: "Please complete the required fields first.",
        showConfirmButton: true,
        timer: 5000,
      });
      return;
    }
    if (this.covidTestForm.invalid) {
      Swal.fire({
        icon: "error",
        title: "",
        text: "Please complete the required fields first.",
        showConfirmButton: true,
        timer: 5000,
      });
      return;
    } else {
      this.personalInfoTab = false;
      this.bookAppointmentTab = true;
      this.confirmationTab = false;
      this.paymentTab = false;
      this.covidTab = false;
      this.submitted = false;
      this.healthDeclarationTab = false;

      this.appointmentForm = this.formBuilder.group({
        stateOnDay7: [
          this.preferredLocation.state,
          [
            Validators.required,
            Validators.pattern("^[a-zA-Z ]+$"),
            // Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
          ],
        ],
        arrivalDate: [this.arrivalDate],
        bookingDate: [
          this.preferredLocation.bookingDate,
          [Validators.required],
        ],
        bookingTime: [
          this.preferredLocation.bookingTime,
          [Validators.required],
        ],
        cityOnDay7: [
          this.preferredLocation.city,
          [
            Validators.required,
            Validators.pattern("^[a-zA-Z ]+$"),
            // Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
          ],
        ],
      });
    }
    this.utility.gotoTop();
  }

  showConfirmation() {
    if (this.registerForm.invalid) {
      Swal.fire({
        icon: "error",
        title: "",
        text: "Please complete the required fields first.",
        showConfirmButton: true,
        timer: 5000,
      });
      return;
    }
    if (this.appointmentForm.invalid) {
      Swal.fire({
        icon: "error",
        title: "",
        text: "Please complete the required fields first.",
        showConfirmButton: true,
        timer: 5000,
      });
      return;
    } else {
      this.personalInfoTab = false;
      this.bookAppointmentTab = false;
      this.confirmationTab = true;
      this.paymentTab = false;
      this.covidTab = false;
      this.healthDeclarationTab = false;
    }
  }

  showPayment() {
    if (this.registerForm.invalid) {
      Swal.fire({
        icon: "error",
        title: "",
        text: "Please complete the required fields first.",
        showConfirmButton: true,
        timer: 5000,
      });
      return;
    }
    if (this.appointmentForm.invalid) {
      Swal.fire({
        icon: "error",
        title: " ",
        text: "Please complete the required fields first.",
        showConfirmButton: true,
        timer: 5000,
      });
      return;
    } else {
      this.initPaymentGatewayForm();
      this.personalInfoTab = false;
      this.bookAppointmentTab = false;
      this.confirmationTab = false;
      this.paymentTab = true;
      this.covidTab = false;
      this.healthDeclarationTab = false;
    }
  }

  onShowOTP(formData) {
    this.submitted = true;

    console.log(formData);

    if (this.paymentGatewayForm.invalid) {
      return;
    }

    if (!this.passengerInformation) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please complete the book appointment form to proceed.",
        showConfirmButton: true,
        timer: 5000,
      });
      return;
    }
    this.submitted = false;

    this.spinnerService.show();
    // this.initialiseOtpForm();
    setTimeout(() => {
      this.spinnerService.hide();
      $("#showOtpForm").trigger("click");
      // showOtpForm
    }, 1000);
  }

  onMakePayment(formData = null) {
    // this.submitted = true;

    console.log(formData);

    // if (this.paymentGatewayForm.invalid) {
    //   return;
    // }

    // if (!this.passengerInformation) {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Oops...",
    //     text: "Please complete the book appointment form to proceed.",
    //     showConfirmButton: true,
    //     timer: 5000,
    //   });
    //   return;
    // }

    // var requestObj = {
    //   ctms_passenger_id: this.passengerInformation.ctms_passenger_id,
    //   payment_status: true,
    // };

    $("#dismissModal").trigger("click");

    this.requestObj["ctms_passenger_id"] =
      this.passengerInformation.ctms_passenger_id;
    this.requestObj["payment_status"] = true;

    console.log(this.requestObj);

    this.spinnerService.show();

    this.apiUrl = environment.AUTHAPIURL + "passenger-payment/update";

    this.http.post<any>(this.apiUrl, this.requestObj).subscribe((data) => {
      console.log("paymentApiResponse: ", data);
      this.spinnerService.hide();
      // $("#dismissModal").trigger("click");

      if (data.status == true) {
        // Swal.fire({
        //   icon: "success",
        //   title: "Success",
        //   text: data.message,
        //   showConfirmButton: true,
        //   timer: 10000,
        // });
        // this.showPayment();
        // this.utility.gotoTop();
        //redirect to home
        // this.router.navigate(["/"]);
        this.router.navigate(["/paymentstatuspage"]);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: data.message,
          showConfirmButton: true,
          timer: 5000,
        });
      }
    });
  }

  onOtpSubmit(otpFormData) {
    this.submitted = true;
    this.requestObj = {};
    this.requestObj.otp = otpFormData.enterOtp;
    console.log("otpFormData: ", otpFormData);
    console.log("loginRequest: ", this.requestObj);

    if (this.otpForm.invalid) {
      return;
    }
    this.submitted = false;
    this.onMakePayment();
  }

  validate(s) {
    let validateRegex = new RegExp(/^\s+|\s\s+|\s+$/g);
    return !s.match(validateRegex);
  }

  onFileChange(event) {
    if (event.target.files.length > 0) {
      this.spinnerService.show();

      const file = event.target.files[0];
      this.file = event.target.files[0];
      // this.filePath = event.target.files[0].name;
      // this.covidTestForm.get("resultFile").setValue(file);

      this.apiUrl = environment.AUTHAPIURL + "file/upload";
      // const reqHeader = new HttpHeaders({
      // 	'Content-Type': 'application/json',
      // 	Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      // });
      const formData = new FormData();
      formData.append("file", this.file);

      // this.fileUrl =
      // 	'http://localhost/eg-ctms-backend/public/uploadReport/sample-COVID-test-report_1624438663.jpg';
      this.http.post<any>(this.apiUrl, formData).subscribe((data) => {
        console.log("uploadApiResponse: ", data);
        this.spinnerService.hide();

        if (data.status == true) {
          this.fileUrl = data.response.url;
          this.filePath = event.target.files[0].name;
          this.covidTestForm.get("resultFile").setValue(file);

          Swal.fire({
            icon: "success",
            title: "Success",
            text: data.message,
            showConfirmButton: true,
            timer: 5000,
          });
          console.log(this.fileUrl);
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text:
              data.response != null ? data.response[0].message : data.message,
            showConfirmButton: true,
            timer: 5000,
          });
        }
      });
    }
  }

  getTravelTypes() {
    this.apiUrl = environment.AUTHAPIURL + "travel-types";

    this.http.get<any>(this.apiUrl).subscribe((data) => {
      console.log("travelTypes: ", data);
      this.travelTypes = data.response;
    });
  }

  getCollectionCenters() {
    this.apiUrl = environment.AUTHAPIURL + "collection-center-list?page=1";

    const obj = {
      per_page: 100,
    };
    this.http.post<any>(this.apiUrl, obj).subscribe((data) => {
      console.log("collectionCenters: ", data);
      this.collectionCenters = data.response;
    });
  }

  getQuestionnaires() {
    let obj = {};
    this.apiUrl = environment.AUTHAPIURL + "questionnaire";

    this.http.post<any>(this.apiUrl, obj).subscribe((data) => {
      console.log("questionnaire: ", data);
      this.questionnaires = data.response;
    });
  }

  updateRegistrationForm(passenger, travel) {
    this.registerForm = this.formBuilder.group(
      {
        emailAddress: [
          passenger.email,
          [Validators.required, Validators.maxLength(45), Validators.email],
        ],
        confirmEmailAddress: [
          passenger.confirm_email,
          [Validators.required, Validators.maxLength(45), Validators.email],
        ],
        firstName: [
          passenger.first_name,
          [
            Validators.required,
            Validators.pattern("^[A-Za-z ]*$"),
            // Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
            // Validators.pattern("^[a-zA-Z]+ [a-zA-Z]+$"),
            Validators.maxLength(45),
          ],
        ],
        middleName: [
          passenger.middle_name,
          [
            // Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
            Validators.pattern("^[A-Za-z ]*$"),
            // Validators.pattern("^[a-zA-Z]+ [a-zA-Z]+$"),
            Validators.maxLength(45),
          ],
        ],
        lastName: [
          passenger.last_name,
          [
            Validators.required,
            // Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
            Validators.pattern("^[A-Za-z ]*$"),
            // Validators.pattern("^[a-zA-Z]+ [a-zA-Z]+$"),
            Validators.maxLength(45),
          ],
        ],
        countryOfResidence: [passenger.country_residence, Validators.required],

        nationality: [passenger.nationality, [Validators.required]],
        phone: [
          passenger.phone,
          [
            Validators.required,
            Validators.pattern("^[0-9]*$"),
            Validators.minLength(9),
          ],
        ],
        passportNumber: [
          passenger.passport_no,
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(15),
          ],
        ],
        gender: [passenger.gender, Validators.required],
        // airline: ['', Validators.required],
        arrivalDate: [travel.arrival_date, Validators.required],
        arrivalState: [travel.arrival_state, Validators.required],
        // countryOfTransit: [travel.transit_country, Validators.required],
        countryOfTransit: [travel.transit_country],
        countryDeparting: [passenger.country_residence, [Validators.required]],
        // returnDate: ['', Validators.required],
        dateOfBirth: [passenger.dob, Validators.required],
        currentAddress: [
          passenger.address_residential,
          [Validators.required, Validators.maxLength(60)],
        ],
        occupation: [
          passenger.occupation,
          [Validators.required, Validators.maxLength(45)],
        ],
      },
      {
        validator: this.utility.MustMatch(
          "emailAddress",
          "confirmEmailAddress"
        ),
      }
    );
  }
  updateNewRegisterionForm() {
    this.registerForm = this.formBuilder.group(
      {
        emailAddress: [
          "",
          [Validators.required, Validators.maxLength(45), Validators.email],
        ],
        confirmEmailAddress: [
          "",
          [Validators.required, Validators.maxLength(45), Validators.email],
        ],
        firstName: [
          "",
          [
            Validators.required,
            // Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
            Validators.pattern("^[A-Za-z ]*$"),
            Validators.maxLength(45),
          ],
        ],
        middleName: [
          "",
          [
            // Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
            Validators.pattern("^[A-Za-z ]*$"),
            Validators.maxLength(45),
          ],
        ],
        lastName: [
          "",
          [
            Validators.required,
            // Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
            Validators.pattern("^[A-Za-z ]*$"),
            Validators.maxLength(45),
          ],
        ],
        countryOfResidence: ["", Validators.required],

        nationality: ["", [Validators.required]],
        phone: [
          "",
          [
            Validators.required,
            Validators.pattern("^[0-9]*$"),
            Validators.minLength(9),
          ],
        ],
        passportNumber: [
          this.passportNumber,
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(15),
          ],
        ],
        gender: ["", Validators.required],
        // airline: ['', Validators.required],
        arrivalDate: ["", Validators.required],
        arrivalState: ["", Validators.required],
        // countryOfTransit: ['', Validators.required],
        countryOfTransit: [""],
        countryDeparting: ["", [Validators.required]],
        // returnDate: ['', Validators.required],
        dateOfBirth: ["", Validators.required],
        currentAddress: ["", [Validators.required, Validators.maxLength(60)]],
        occupation: ["", [Validators.required, Validators.maxLength(45)]],
      },
      {
        validator: this.utility.MustMatch(
          "emailAddress",
          "confirmEmailAddress"
        ),
      }
    );
  }

  getPassportDetails(event: any) {
    let obj = {};
    let passportNumber = event.target.value;
    if (passportNumber.trim().length === 0) return;

    if (/^[A-Za-z0-9]*$/i.test(passportNumber)) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.spinnerService.show();
        if (event.keyCode != 13) {
          this.apiUrl =
            environment.AUTHAPIURL +
            "passenger-existing-record/" +
            passportNumber;

          this.http.post<any>(this.apiUrl, obj).subscribe((data) => {
            console.log("passportDetails: ", data);
            if (data.status == true) {
              this.passportDetails = data.response;
              Swal.fire({
                icon: "success",
                title: "Success",
                text: "Please confirm the information and update accordingly.",
                showConfirmButton: true,
                timer: 4000,
              });
              this.kinInfo = {
                address: data.response.emergency_contact_address,
                fullname: data.response.emergency_contact_fullname,
                phone: data.response.emergency_contact_phone,
              };

              this.updateRegistrationForm(
                this.passportDetails.passenger_info,
                this.passportDetails.travel_info
              );
              this.preboardingFormUpdate(this.kinInfo);
              this.spinnerService.hide();
            } else {
              this.passportNumber =
                this.registerForm.get("passportNumber").value;
              this.updateNewRegisterionForm();
              this.spinnerService.hide();
            }
          });
        }
      }, 2000);
    }
  }
}
